import type {FC} from "react";
import {registerToast} from "services/notification/toast";
import {useNotifications} from "services/notification/useNotifications";

export const ToastBridge: FC = () => {
  const {addNotification} = useNotifications();
  registerToast(addNotification);
  return null;
};
